import { Navigate, useLocation } from 'react-router-dom';

/**
 * The interactive step-by-step application form that used to live at
 * /apply-conversational was retired; the regular family application form at
 * /apply-classic is the only one offered now. Old links (emails, bookmarks,
 * school websites) still point here, and families type the short /apply, so send them on and keep the query string
 * (e.g. ?school=...) so any pre-selection they carried survives the hop.
 *
 * Deliberately not lazy-loaded: a redirect should never need its own chunk.
 */
const LegacyApplyRedirect = () => {
  const location = useLocation();
  return <Navigate replace to={{ pathname: '/apply-classic', search: location.search }} />;
};

export default LegacyApplyRedirect;
